<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.COMPETENCIAS_ATRIBUCIONES}">
                    <div class="col-sm-6 text-sm-right">
                        <button *hasPermission="{app: constant.COMPETENCIAS_ATRIBUCIONES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let atribucion of dataApp;let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{atribucion.nombre}}</td>
                            <td>{{((atribucion.estado == '1')? 'Activo': 'Inactivo')}}
                            </td>
                            <td class="text-center" style="width:50px">
                                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.COMPETENCIAS_ATRIBUCIONES}">
                                    <button *hasPermission="{app: constant.COMPETENCIAS_ATRIBUCIONES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(atribucion)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button *hasPermission="{app: constant.COMPETENCIAS_ATRIBUCIONES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(atribucion.idSprAtribucion)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-atribucion" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<jw-modal id="{{nameModal}}">

    <div class="modal-dialog" style="padding-top:5%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="modal.close();" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <form class="needs-validation" novalidate id="formAtribucion" [formGroup]="formAtribucion">
                    <div class="row">

                        <input type="hidden" id="idSprAtribucion" formControlName="idSprAtribucion">
                        <div class="form-floating mb-3">
                            <input class="form-control" style="background-color: #f5f4f4;" readonly="readonly" value="{{nombreUnidad}}">

                            <label for="nombre">Unidad</label>
                        </div>

                        <div class="form-floating mb-3">
                            <textarea type="text" class="form-control" maxlength="2000" [(ngModel)]="textoAreaValue" (keyup)="onKey($event)" rows="7" cols="30" formControlName="nombre" id="nombre" [ngClass]="{ 'is-invalid': this.formAtribucion.get('nombre')?.errors && this.formSubmitted,'is-valid': this.formAtribucion.value.nombre}"
                                style="height: 241px;">
                            </textarea>
                            <small class="invalid-feedback" *ngIf="this.formAtribucion.get('nombre')?.errors?.['required'] && this.formSubmitted">
                                Campo requerido</small>
                            <label for="idSprAtribucion" class="col-form-label text-md-right"><b>Nombre</b>
                            </label>
                            <div id="contador">{{ contador }} caracteres restantes
                            </div>
                        </div>

                        <div class="form-floating mb-3">
                            <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                            'is-invalid': this.formAtribucion.get('estado')?.errors && this.formSubmitted,
                            'is-valid': !this.formAtribucion.get('estado')?.errors,
                          }">
                                <option value="1" selected>Activo</option>
                                <option value="2">Inactivo</option>
                            </select>
                            <label for="estado">Estado</label>
                            <small class="invalid-feedback" *ngIf="this.formAtribucion.get('estado')?.errors?.['required'] && this.formSubmitted">
                                Campo
                                requerido</small>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>